import io from "socket.io-client"
<template>
  <div>
    <loading :active.sync="loading"
             :loader="'dots'"
             :color="'#58f0ac'"
             :width="128"
             :background-color="'#000'"
             :opacity="0.75"
             :can-cancel="false"
             :is-full-page="true"></loading>
    <div  class="row justify-content-center" v-if="serverError">
      <div class="col-12">
        <h1 style="text-align: center; margin-top:15%;">SERVER NEDOSTUPAN!</h1>
      </div>
      <div class="col-12 d-flex justify-content-around">
        <base-button type="info" @click="getDevice()">OSVEŽI</base-button>
      </div>
    </div>
    <div class="row card-deck" v-else>
      <div class="col-md-12 col-lg-6 col-xl-4 mt-3">
        <card class="text-center  h-100">
          <h3 class="card-title">TOPLOTNA PUMPA</h3>
          <div class="row" style="height: 100%">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid" style="font-size:20px;">
              <p style="margin-top:35px;">
                <b>  {{firstname}} {{lastname}}</b>
              </p>
              <p>
                Model:
                <b>{{model}}</b>
              </p>
              <p>
                Garancija:
                <b>{{warranty}}</b>
              </p>
              <p v-if="WIFI">
                WiFi:
                <b style="color:#42b883">Povezan</b>
              </p>
              <p v-else>
                WiFi:
                <b style="color:#fc575e">NIJE POVEZAN</b>
              </p>
              <!--
              <p>
                Korak:
                <b>{{KOR}}</b>
              </p>
              -->
              <p>Greške: {{GRE}}</p>
              <p>S/N: {{serial}}</p>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid">
              <img slot class="mt-4 mt-xl-0" :src="toplotnaPumpa"  height="240px" alt="Card image cap" />
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-4 mt-3" v-if="A1Type != 0 && WIFI">
        <card class="text-center  h-100">
          <h3 class="card-title">AKUMULACIONI TANK 1</h3>
          <div class="row" style="height: 100%">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid">
              <p>
                <toggle-button
                  v-model="A1SW1"
                  :height="40"
                  :width="152"
                  :font-size="18"
                  :labels="{checked: 'UPALJENO', unchecked: 'UGAŠENO'}"
                  :color="{checked: '#42b883', unchecked: '#bfcbd9'}"
                  style="margin-top:15px; margin-left:8px;margin-right:8px;"
                  :sync="true"
                  @click.native="A1SPromenjeno($event, 1)"
                />
              </p>
              <p>
                <toggle-button
                  v-model="A1SW2"
                  :height="40"
                  :width="152"
                  :font-size="18"
                  :color="{checked: 'red', unchecked: 'blue'}"
                  :labels="{checked: 'GREJANJE', unchecked: 'HLADJENJE'}"
                  style="margin-top:15px; margin-left:8px;margin-right:8px;"
                  :sync="true"
                  @click.native="A1SPromenjeno($event, 2)"
                  v-if="A1Type == 3"
                />
              </p>
              <p style="margin-top:20px;" class="parameter-text">TRENUTNA TEMPERATURA:</p>
              <p class="temperature-text">{{A1M}}&#8451</p>
              <div v-if="A1SW1">
                <p style="margin-top:10px;" class="parameter-text">ZADATA TEMPERATURA:</p>
                <p
                  style="margin-bottom:5px;"
                  class="temperature-text"
                >{{A1Z}}&#8451</p>
                <base-button icon round class="mx-2 minus-btn" @click="A1ZMinus()">
                  <i class="fas fa-minus"></i>
                </base-button>
                <base-button icon round class="mx-2 plus-btn" @click="A1ZPlus()">
                  <i class="fas fa-plus"></i>
                </base-button>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid">
              <img slot class="mt-4 mt-xl-0" :src="akumulacioniTank"  height="240px" alt="Card image cap" />
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-4 mt-3" v-if="A2Type != 0  && WIFI">
        <card class="text-center  h-100">
          <h3 class="card-title">AKUMULACIONI TANK 2</h3>
          <div class="row" style="height: 100%">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid">
              <p>
                <toggle-button
                  v-model="A2SW1"
                  :height="40"
                  :width="152"
                  :font-size="18"
                  :labels="{checked: 'UPALJENO', unchecked: 'UGAŠENO'}"
                  :color="{checked: '#42b883', unchecked: '#bfcbd9'}"
                  style="margin-top:15px"
                  :sync="true"
                  @click.native="A2SPromenjeno($event, 1)"
                />
              </p>
              <p>
                <toggle-button
                  v-model="A2SW2"
                  :height="40"
                  :width="152"
                  :font-size="18"
                  :color="{checked: 'red', unchecked: 'blue'}"
                  :labels="{checked: 'GREJANJE', unchecked: 'HLADJENJE'}"
                  style="margin-top:15px; margin-left:8px;margin-right:8px;"
                  :sync="true"
                  @click.native="A2SPromenjeno($event, 2)"
                  v-if="A2Type == 3"
                />
              </p>
              <p style="margin-top:20px;" class="parameter-text">TRENUTNA TEMPERATURA:</p>
              <p class="temperature-text">{{A2M}}&#8451</p>
              <div v-if="A2SW1">
                <p style="margin-top:10px;" class="parameter-text">ZADATA TEMPERATURA:</p>
                <p
                  style="margin-bottom:5px;"
                  class="temperature-text"
                >{{A2Z}}&#8451</p>
                <base-button icon round class="mx-2 minus-btn" @click="A2ZMinus()">
                  <i class="fas fa-minus"></i>
                </base-button>
                <base-button icon round class="mx-2 plus-btn" @click="A2ZPlus()">
                  <i class="fas fa-plus"></i>
                </base-button>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid">
              <img slot class="mt-4 mt-xl-0" :src="akumulacioniTank" height="240px" alt="Card image cap" />
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-4 mt-3" v-if="UType != 0 && WIFI">
        <card class="text-center h-100">
          <h3 class="card-title">OBJEKAT</h3>
          <div class="row" style="height: 100%">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid">
              <p class="parameter-text">CIRKULACIJA</p>
              <p>
                <toggle-button
                  v-model="OBJSW1"
                  :height="40"
                  :width="152"
                  :font-size="18"
                  :color="{checked: '#42b883', unchecked: '#bfcbd9'}"
                  :labels="{checked: 'UPALJENO', unchecked: 'UGAŠENO'}"
                  style="margin-top:2px"
                  :sync="true"
                  @click.native="UNSPromenjeno"
                />
              </p>
              <p class="parameter-text">REŽIM RADA</p>
              <p>
                <toggle-button
                  v-model="OBJSW2"
                  :height="40"
                  :width="152"
                  :font-size="18"
                  :color="{checked: '#42b883', unchecked: '#42b883'}"
                  :labels="{checked: 'KALENDAR', unchecked: 'RUČNO'}"
                  style="margin-top:2px"
                  :sync="true"
                  @click.native="UNRPromenjeno"
                />
              </p>
              <p style="margin-top:15px;" class="parameter-text" v-if="SPM != 255">UNUTRA &nbsp;	| &nbsp;	 SPOLJA</p>
			  <p style="margin-top:15px;" class="parameter-text" v-else>UNUTRA</p>
              <p class="temperature-text" v-if="SPM != 255">{{UNM}}&#8451 | {{SPM}}&#8451 </p>
			  <p class="temperature-text" v-else>{{UNM}}&#8451 </p>
              <div v-if="!OBJSW2">
                <p style="margin-top:10px;" class="parameter-text">ZADATA TEMPERATURA</p>
                <p style="margin-bottom:10px;" class="temperature-text">{{UNZ}}&#8451</p>
                <base-button icon round class="mx-2 minus-btn" @click="UNZMinus()">
                  <i class="fas fa-minus"></i>
                </base-button>
                <base-button icon round class="mx-2 plus-btn" @click="UNZPlus()">
                  <i class="fas fa-plus"></i>
                </base-button>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 card-body-mid">
              <img slot class="mt-4 mt-xl-0" :src="objekat"  height="240px" alt="Card image cap" />
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-4 mt-3" v-if="WIFI">
        <card class="text-center h-100">
          <h3 class="card-title">ULAZ - IZLAZ PRIMARA</h3>
          <div class="row d-flex justify-content-center align-items-center" style="height: 100%">
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-double-right"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">ULAZ</p>

              <p style="font-size:25px; margin-top:15px;" class="temperature-text">{{UPT}}&#8451</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-double-left"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">IZLAZ</p>

              <p style="font-size:25px; margin-top:15px;" class="temperature-text">{{IPT}}&#8451</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-sound-wave"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">PROTOK</p>

              <p style="font-size:25px; margin-top:15px;" class="temperature-text">{{PPR}} l/s</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-atom"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">SNAGA</p>

              <p style="font-size:25px; margin-top:15px;" class="temperature-text">{{SPR}}kW/h</p>
            </div>
          </div>
          <!---
          <p
            class="card-text mt-5"
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas euismod arcu tempus augue cursus finibus</p>
          -->
          <!---<a href="#" class="btn btn-primary">Go somewhere</a>--->
        </card>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-4 mt-3" v-if="WIFI">
        <card class="text-center h-100">
          <h3 class="card-title">ULAZ - IZLAZ SEKUNDARA</h3>
          <div class="row d-flex justify-content-center align-items-center" style="height: 100%">
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-double-right"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">ULAZ</p>

              <p style="font-size:25px; margin-top:15px;" class="temperature-text">{{UST}}&#8451</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-double-left"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">IZLAZ</p>

              <p style="font-size:25px; margin-top:15px;" class="temperature-text">{{IST}}&#8451</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-sound-wave"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">PROTOK</p>

              <p style="font-size:25px; margin-top:15px" class="temperature-text">{{PSE}} l/s</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-3">
              <i
                class="tim-icons icon-atom"
                style="font-size:50px; color: #1d8cf8; margin-top:70px"
              ></i>
              <p style="margin-top:10px; font-size:20px;" class="parameter-text">SNAGA</p>

              <p style="font-size:25px; margin-top:15px" class="temperature-text">{{SSE}} kW/h</p>
            </div>
          </div>
          <!---
          <p
            class="card-text mt-5"
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas euismod arcu tempus augue cursus finibus</p>
          -->
          <!---<a href="#" class="btn btn-primary">Go somewhere</a>--->
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import toplotnaPumpa from "@/assets/images/toplotna-pumpa.png";
import akumulacioniTank from "@/assets/images/akumulacioni-tank.png";
import sanitarniBojler from "@/assets/images/sanitarni-bojler.png";
import objekat from "@/assets/images/objekat1.png";
import UserServices  from "@/services/UserServices";


export default {
  data() {
    return {
      serverError: false,
      toplotnaPumpa: toplotnaPumpa,
      akumulacioniTank: akumulacioniTank,
      sanitarniBojler: sanitarniBojler,
      objekat: objekat,
      loading: false,
      clickingTimer1: null,
      clickingTimer2: null,
      clickingTimer3: null,
      deviceResponseTimer: null,
      firstname: "",
      lastname: "",
      model: "",
      warranty: "",
      WIFI: false,
      serial: "000000000",
      A1Type: 0,
      A2Type: 0,
      UType: 0,
      A1S: 0,
      A1SW1: false,
      A1SW2: false,
      A2S: 0,
      A2SW1: false,
      A2SW2: false,
      UNS: 0,
      UNR: 0,
      A1M: 0,
      A1Z: 0,
      A2M: 0,
      A2Z: 0,
      UNM: 0,
	  SPM: 0,
      UNZ: 0,
      OBJSW1: false,
      OBJSW2: false,
      UPT: 0,
      IPT: 0,
      PPR : 0,
      SPR: 0,
      UST: 0,
      IST: 0,
      PSE: 0,
      SSE: 0,
      GRE: 0,
      KOR: 0
    };
  },
  computed: {},
  methods: {
    async getDevice(){
      try {
        this.loading = true
        let response = await UserServices.getDeviceData()
        let data = response.data.data
        this.firstname = data.User.firstname
        this.lastname = data.User.lastname
        this.model = data.model
        this.warranty = data.warranty
        this.WIFI = data.WIFI
        this.serial = data.serial
        this.A1Type = data.A1Type
        this.A2Type = data.A2Type
        this.UType = data.UType
        this.A1M = data.A1M
        this.A2M = data.A2M
        this.SPM = data.SPM
        this.UNM = data.UNM
        this.UPT = data.UPT
        this.IPT = data.IPT
        this.PPR = data.PPR
        this.UST = data.UST
        this.IST = data.IST
        this.PSE = data.PSE
        this.SPR = data.SPR
        this.SSE = data.SSE
        this.A1Z = data.A1Z
        this.A2Z = data.A2Z
        this.A1S = data.A1S
        this.A2S = data.A2S
        this.UNZ = data.UNZ
        this.UNS = data.UNS
        this.UNR = data.UNR
        this.KOR = data.KOR
        this.GRE = data.GRE

        // A1 - akumulacija ugasena
        if (this.A1S == 1) {
          this.A1SW1 = false;
        }
        // A1 - akumulacija upaljena
        if (this.A1S == 4 || this.A1S == 8 || this.A1S == 10) {
          this.A1SW1 = true
        }

        // A1 - hladjenje (upaljeno ili ugaseno)
        if (this.A1S == 4) {
          this.A1SW2 = false
        }

        // A1 - grejanje (upaljeno ili ugaseno)
        if (this.A1S == 8) {
          this.A1SW2 = true
        }

        // A2 - akumulacija ugasena
        if (this.A2S == 1) {
          this.A2SW1 = false;
        }

        //A2 - akumulacija upaljena
        if (this.A2S == 13 || this.A2S == 17 || this.A2S == 19) {
          this.A2SW1 = true
        }

        // A2 - hladjenje (upaljeno ili ugaseno)
        if (this.A2S == 13) {
          this.A2SW2 = false
        }

        // A2 - grejanje (upaljeno ili ugaseno)
        if (this.A2S == 17) {
          this.A2SW2 = true
        }

        if (this.UNS == 1) {
          this.OBJSW1 = true
        } else {
          this.OBJSW1 = false
        }

        if (this.UNR == 1) {
          this.OBJSW2 = true
        } else {
          this.OBJSW2 = false
        }

        this.loading = false;
        this.serverError = false
      }catch(err){
        console.log(err)
        this.loading = false
        this.serverError = true
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
      }

    },
    A1ZPlus: function() {
      this.A1Z = this.A1Z + 0.5;
      if(this.clickingTimer1) clearTimeout(this.clickingTimer1);
      this.clickingTimer1 = setTimeout(this.sendA1Z, 1500);
      /*
      this.$notify({
        verticalAlign: "bottom",
        horizontalAlign: "right",
        message: "Komanda poslata kontrolnoj jedinici. Cekamo odobrenje..."
      });
      */
    },
    A1ZMinus: function() {
      this.A1Z = this.A1Z - 0.5;
      if(this.clickingTimer1) clearTimeout(this.clickingTimer1);
      this.clickingTimer1 = setTimeout(this.sendA1Z, 1500);

    },
    A2ZPlus: function() {
      this.A2Z = this.A2Z + 0.5;
      if(this.clickingTimer2) clearTimeout(this.clickingTimer2);
      this.clickingTimer2 = setTimeout(this.sendA2Z, 1500);
    },
    A2ZMinus: function() {
      this.A2Z = this.A2Z - 0.5;
      if(this.clickingTimer2) clearTimeout(this.clickingTimer2);
      this.clickingTimer2 = setTimeout(this.sendA2Z, 1500);
    },
    UNZPlus: function() {
      this.UNZ = this.UNZ + 0.5;
      if(this.clickingTimer3) clearTimeout(this.clickingTimer3);
      this.clickingTimer3 = setTimeout(this.sendUNZ, 1500);
    },
    UNZMinus: function() {
      this.UNZ = this.UNZ - 0.5;
      if(this.clickingTimer3) clearTimeout(this.clickingTimer3);
      this.clickingTimer3 = setTimeout(this.sendUNZ, 1500);
    },
    A1SPromenjeno: async function(e, switchNum) {
      try {
        e.preventDefault();
        let data = {}
        data.source = "A1S"
        if(this.A1Type == 4) data.isPTV = true
        else data.isPTV = false
        data.power = this.A1SW1
        data.state = this.A1SW2
        if (switchNum == 1) {
          data.power = !this.A1SW1
        }
        if (switchNum == 2) {
          if (!this.A1SW1) {
            this.A1SW2 = !this.A1SW2
            data.state = this.A1SW2
            return
          } else {
            data.state = !this.A1SW2
          }
        }
        this.loading = true;
        await UserServices.newState(data)
        this.deviceResponseTimer = setTimeout(this.deviceResponseTimerExpired, 15000);

      }catch(err){
        this.loading = false
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
        this.getDevice()
      }
    },
    A2SPromenjeno: async function(e, switchNum) {
      try {
        e.preventDefault();

        let data = {}
        data.source = "A2S"
        if(this.A2Type == 4) data.isPTV = true
        else data.isPTV = false
        data.power = this.A2SW1
        data.state = this.A2SW2
        if (switchNum == 1) {
          data.power = !this.A2SW1
        }
        if (switchNum == 2) {
          if (!this.A2SW1) {
            this.A2SW2 = !this.A2SW2
            data.state = this.A2SW2
            return
          } else {
            data.state = !this.A2SW2
          }
        }
        this.loading = true;
        await UserServices.newState(data)
        this.deviceResponseTimer = setTimeout(this.deviceResponseTimerExpired, 15000);
      } catch(err){
        this.loading = false
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
        this.getDevice()
      }
    },
    UNSPromenjeno: async function(e){
      try {
        e.preventDefault();
        let data = {}
        data.source = "UNS"
        data.power = !this.OBJSW1
        this.loading = true;
        await UserServices.newState(data)
        this.deviceResponseTimer = setTimeout(this.deviceResponseTimerExpired, 15000);
      } catch(err){
        this.loading = false
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
        this.getDevice()
      }

    },
    UNRPromenjeno: async function(e){
      try {
        e.preventDefault();
        //if(!OBJSW1) return
        let data = {}
        data.source = "UNR"
        data.state = !this.OBJSW2
        this.loading = true;
        await UserServices.newState(data)
        this.deviceResponseTimer = setTimeout(this.deviceResponseTimerExpired, 15000);
      } catch(err){
        this.loading = false
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
        this.getDevice()
      }

    },
    sendA1Z: async function(){
      try {
        let data = {}
        data.source = "A1Z"
        data.state = this.A1Z
        this.loading = true;
        await UserServices.newState(data)
        this.deviceResponseTimer = setTimeout(this.deviceResponseTimerExpired, 15000);
      } catch(err){
        this.loading = false
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
        this.getDevice()
      }
    },
    sendA2Z: async function(){
      try {
        let data = {}
        data.source = "A2Z"
        data.state = this.A2Z
        this.loading = true;
        await UserServices.newState(data)
        this.deviceResponseTimer = setTimeout(this.deviceResponseTimerExpired, 15000);
      } catch(err){
        this.loading = false
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
        this.getDevice()
      }
    },
    sendUNZ: async function(){
      try{
        let data = {}
        data.source = "UNZ"
        data.state =  this.UNZ
        this.loading = true;
        await UserServices.newState(data)
        this.deviceResponseTimer = setTimeout(this.deviceResponseTimerExpired, 15000);
      }catch(err){
        this.loading = false
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "right",
          type: 'warning',
          message: "GREŠKA! SERVER NEDOSTUPAN!"
        });
        this.getDevice()
      }
    },
    deviceResponseTimerExpired(){
      this.loading = false
      this.$notify({
        verticalAlign: "bottom",
        horizontalAlign: "right",
        type: 'warning',
        message: "GREŠKA! UREDJAJ NE ODGOVARA NA ZADATU KOMANDU!"
      });
      this.getDevice();
    }
  },
  mounted() {
    this.i18n = this.$i18n;
    this.$socket.client.io.opts.query = { token: localStorage.getItem("user_jwt")}
    this.$socket.client.open();
    this.getDevice()
  },
  sockets: {
    connect: function () {
      console.log('Socket connected!')
    },
    P1: function (data) {
      this.A1M = parseFloat(data.A1M)
      this.A2M = parseFloat(data.A2M)
      this.SPM = parseFloat(data.SPM)
      this.UNM = parseFloat(data.UNM)
      this.UPT = parseFloat(data.UPT)
      this.IPT = parseFloat(data.IPT)
      this.PPR = parseFloat(data.PPR)
      this.UST = parseFloat(data.UST)
      this.IST = parseFloat(data.IST)
      this.PSE = parseFloat(data.PSE)
      this.SPR = parseFloat(data.SPR)
      this.SSE = parseFloat(data.SSE)
      console.log(data)
    },
    P2: function (data) {
      this.A1Z = parseFloat(data.A1Z)
      this.A2Z = parseFloat(data.A2Z)
      this.A1S = parseFloat(data.A1S)
      this.A2S = parseFloat(data.A2S)
      this.UNZ = parseFloat(data.UNZ)
      this.UNS = parseFloat(data.UNS)
      this.UNR = parseFloat(data.UNR)
      this.GRE = parseFloat(data.GRE)

      // A1 - akumulacija ugasena
      if(this.A1S == 1) {this.A1SW1 = false; }
      // A1 - akumulacija upaljena
      if(this.A1S == 4 ||  this.A1S == 8  || this.A1S == 10) {this.A1SW1 = true}

      // A1 - hladjenje (upaljeno ili ugaseno)
      if(this.A1S == 4) {this.A1SW2 = false}

      // A1 - grejanje (upaljeno ili ugaseno)
      if(this.A1S == 8) {this.A1SW2 = true}

      // A2 - akumulacija ugasena
      if(this.A2S == 1) {this.A2SW1 = false;}

      //A2 - akumulacija upaljena
      if(this.A2S == 13 ||  this.A2S == 17  || this.A2S == 19) {this.A2SW1 = true}

      // A2 - hladjenje (upaljeno ili ugaseno)
      if(this.A2S == 13) {this.A2SW2 = false}

      // A2 - grejanje (upaljeno ili ugaseno)
      if(this.A2S == 17) {this.A2SW2 = true}

      if(this.UNS == 1) { this.OBJSW1 = true}
      else { this.OBJSW1 = false }

      if(this.UNR == 1) { this.OBJSW2 = true}
      else { this.OBJSW2 = false }


      if(this.deviceResponseTimer) clearTimeout(this.deviceResponseTimer);

      this.loading = false;

      console.log(data)
    },
    WIFI: function (data) {
      if(data.status == "online") this.WIFI = true
        else this.WIFI = false
    }
  }
};
</script>
<style>
  .card {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .card:hover {
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  }

   .card-title{
     font-weight: 500 !important;
     letter-spacing: 0.3px;
   }

  .card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .card-text {
    /*position: absolute;*/
    /*bottom: 10px;*/
    margin-top:10px;
    text-align: center;
  }

  .minus-btn {
      background-image: linear-gradient(to right, #6dd5fa, #2980b9);
  }

  .plus-btn {
    background-image: linear-gradient(to right, #f7b42c, #fc575e);
  }

  .minus-btn:hover,
  .minus-btn:focus,
  .minus-btn:focus,
  .minus-btn:active,
  .minus-btn:active:focus,
  .minus-btn:active:hover {
    background-image: linear-gradient(to right, #6dd5fa, #2980b9) !important;;
  }


  .plus-btn:hover,
  .plus-btn:focus,
  .plus-btn:active,
  .plus-btn:active:focus,
  .plus-btn:active:hover {
    background-image: linear-gradient(to right, #f7b42c, #fc575e) !important;
  }

.parameter-text {
  font-weight: bold;
  letter-spacing: 0.25px;
}

.temperature-text {
  font-weight: 510;
  letter-spacing: 1.5px;
  font-size:30px;
}

.card-body-mid {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>

